// A brand's unsent message to an athlete on a talent sheet, kept in sessionStorage while they
// sign in, so the message dialog can reopen with it.

const DRAFT_KEY = 'talentSheetMessageDraft'

interface Draft {
  sheetId: string
  athleteId: string
  message: string
}

export const saveDraft = (draft: Draft) => {
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft))
  } catch {
    // Storage blocked: the brand retypes the message after signing in
  }
}

/** The saved draft for this athlete on this sheet, if any, removing it from storage */
export const takeDraft = (sheetId: string, athleteId: string): string | null => {
  try {
    const draft = JSON.parse(sessionStorage.getItem(DRAFT_KEY) ?? 'null') as Draft | null
    if (draft?.sheetId !== sheetId || draft.athleteId !== athleteId) return null
    sessionStorage.removeItem(DRAFT_KEY)
    return draft.message
  } catch {
    return null
  }
}
